import React, {useState} from "react";
import Grid from "@material-ui/core/Grid";
import {FormActionButtons} from "../../../../components/FormActionButton";
import {FormHeader} from "../../../../components/FormHeader";
import "../../../../assets/scss/Static.scss";
import {CustomModal} from "../../../../components/CustomModal";
import {PaymentMethods} from "../../../../components/PaymentMethods";
import {not_validate_value} from "../../../../App";
import {Hide} from "../../../../components/Hide";
import {StaffAutoComplete} from "../../../../components/fields/StaffAutoComplete";
import {CustomRadioGroup} from "../../../../components/CustomRadioGroup";
import {Loading} from "../../../../components/Loading";
import moment from "moment";


export const ExpensePaymentModal = props => {
    const [new_payment, setNewPayment] = useState( {
        [props.name]: props.id,
        payment_type: props.payment_type,
        payment_date: moment().format("YYYY-MM-DD")
    });

    const [helper_text, setHelperText] = useState( {})
    const [total_paid, setTotalPaid] = useState( )
    const [show_paid_by, setShowPaidBy] = useState( false)
    const [is_loading, setIsLoading] = useState( false)

    const handlePaymentFormSaveButton = async () => {
        await setIsLoading(true);
        let response = await props.CreatePayment(new_payment);
        if (response.status) {
            await props.handleModalClose();
        } else {
            await setHelperText(response.error_feedback);
        }
        await setIsLoading(false);
    };

    const handleNewPaymentFieldChange = (name, newValue) => {
        if (name === "payment_method"){
            if (!not_validate_value.includes(newValue)) {
                if (newValue.name === "Cash") {
                    setShowPaidBy(true)
                } else {
                    setShowPaidBy(false)
                }
                newValue = newValue.id;
            }else{
                setShowPaidBy(false)
            }
        }

            setTotalPaid(parseFloat(total_paid) + (parseInt(newValue === '' ? 0 : newValue) - parseFloat(new_payment[name] === '' ? 0 : new_payment[name])));
            setNewPayment({...new_payment, [name]: newValue});
    };


        return (
                <CustomModal
                    open={props.formOpen}
                >
                        <Grid container  spacing={2}>

                            <FormHeader
                                title="Payment_form.header"
                                handleClose={props.handleModalClose}
                            />
                            <Hide hide={!is_loading}>
                                <Loading/>
                            </Hide>

                            <Hide hide={is_loading}>
                            <Grid item xs={12}>
                                <PaymentMethods
                                    paymentMethodFullObject
                                    assigned_to="expenses"
                                    required={true}
                                    new_payment={new_payment}
                                    helper_text={helper_text}
                                    handleNewPaymentFieldChange={handleNewPaymentFieldChange}
                                />
                            </Grid>

                            <Hide hide={!show_paid_by}>
                                <Grid item xs={12}>
                                    <StaffAutoComplete
                                        required={true}
                                        name='paid_by'
                                        label="paid_by"
                                        onChangeHandle={handleNewPaymentFieldChange}
                                        error={helper_text.paid_by !== undefined}
                                        helper_text={helper_text.paid_by}
                                        value={new_payment.paid_by}
                                    />
                                </Grid>
                            </Hide>

                            <FormActionButtons
                                errorMsg={helper_text.non_field_errors}
                                handleCancelButton={props.handleModalClose}
                                handleSaveButton={handlePaymentFormSaveButton}
                            />

                            </Hide>

                        </Grid>
                </CustomModal>

        );
    }


